// extracted by mini-css-extract-plugin
export var formContainer = "_hk-0";
export var message = "_hk-1";